export default "__VITE_ASSET__DNcNgSq1__"